<template>
  <div class="houseThree" :style="{ 'margin-top': '60px' }">
    <h3 :style="{ 'margin-bottom': '30px' }">水电气</h3>
    <!-- 单位信息 -->
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="weglist"
      :params="tableParams"
      :style="{ height: '500px', width: '739px' }"
    >
      <template #recodDate="{ row }">
        {{ formatDateHMS(row.recodDate) }}
      </template>

      <template #waterValue="{ row }"> {{ row.waterValue }}吨 </template>
      <template #electricityValue="{ row }">
        {{ row.electricityValue }}度
      </template>
      <template #gasValue="{ row }"> {{ row.gasValue }}立方 </template>
    </h-table>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, watchEffect } from "vue";
import { weglist } from "@/api/realPopulation/realPopulation.js";
import { formatDateHMS } from "@/utils/index.js";

export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: {},
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      tableParams: {
        houseId: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        {
          label: "水用量",
          slot: "waterValue",
        },
        {
          label: "电用量",
          slot: "electricityValue",
        },
        {
          label: "煤气用量",
          slot: "gasValue",
        },
        {
          label: "记录日期",
          slot: "recodDate",
        },
      ],
    });
    const tableRef = ref("tableRef");
    const refData = toRefs(state);
    // const weglistAxios = async () => {
    //   const params = {
    //     houseId: 82,
    //     // props.form.houseId,
    //     limit: 20,
    //     page: 1
    //   };
    //   const res = await weglist(params);
    //   console.lopg(res, 666666);
    // };
    // weglistAxios();

    const submiThree = () => {
      state.tableParams.houseId = props.form.houseId;
      tableRef.value && tableRef.value.refresh();
    };
    watchEffect(() => {
      // submiThree();
    });
    return {
      ...refData,
      submiThree,
      tableRef,
      weglist,
      formatDateHMS,
    };
  },
});
</script>
<style lang="scss" scoped>
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.houseCount {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .houseTop {
    display: flex;
    justify-content: space-around;
    background: #f1f1f1;
    line-height: 40px;
  }
  .houseTitle {
    width: 50%;
    text-align: center;
  }
  .houseBottom {
    display: flex;
    justify-content: space-around;
    line-height: 30px;
  }
}
</style>
